<template>
    <div>
        <div class="common-header-wrap">
            <mt-header class="common-header" title="产品兑换">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="goods-list double-column" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <index-prod-item class="goods-item" v-for="item in goodsList" :key="item.pgoods_id" :item="item">
            </index-prod-item>
        </div>
        <empty-record  v-if="goodsList.length === 0"></empty-record>
    </div>
</template>

<script>
import { Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import IndexProdItem from './IndexProdItem'
import { getPointsgoodsList } from '../../../api/homePointsgoods'
export default {
  name: 'index',
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      pageTotal: 1, // 总页数
      goodsList: [] // 商品列表
    }
  },
  components: {
    EmptyRecord,
      IndexProdItem
  },
  methods: {
    getPointsgoodsList (ispush) {
      Indicator.open()
      let params = this.params
      getPointsgoodsList(params).then(res => {
        Indicator.close()

        if (ispush) {
          this.goodsList = this.goodsList.concat(res.result.goods_list)
        } else {
          this.goodsList = res.result.goods_list
        }
        this.pageTotal = res.result.page_total
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore && this.params.page <= this.pageTotal) {
        this.loading = false
        this.getPointsgoodsList(true)
      }
    },

  }
}
</script>

<style scoped lang="scss">
    .goods-list{padding:0 15px;}
    .goods-list.double-column {display: flex;-webkit-flex-wrap: wrap;flex-wrap: wrap;margin-top: 10px}
    .goods-list.double-column .goods-item{-webkit-box-flex: 1;-webkit-flex: 1;flex: 1;-webkit-flex-basis: 48%;flex-basis: 48%;max-width: calc((100% - 15px) / 2);margin-right:15px}
    .goods-list.double-column .goods-item:nth-child(2n) {margin-right: 0}
</style>
